import React from 'react';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';

import { StyledIcon } from 'constants/icons';

import { Typography4 } from 'uiToolkit/Typography';

const SidepanelHeader = ({
  icon,
  text,
  onCancel,
  loading,
  shrink = false,
  withBottomBorder = true,
  fontWeight = 400,
  padding = '16px 1.5rem 18px',
  textVariant = 'body2',
  bottomComponent = null,
}) => (
  <>
    <Container padding={padding} shrink={shrink} withBottomBorder={withBottomBorder}>
      {icon}
      <Typography4 variant={textVariant} weight={fontWeight}>
        {text}
      </Typography4>
      <Button onClick={onCancel} disabled={loading}>
        <StyledIcon>
          <CloseIcon fontSize="small" />
        </StyledIcon>
      </Button>
    </Container>
    {bottomComponent}
  </>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => props.padding};
  border-bottom: ${(props) => (props.withBottomBorder ? '1px solid #eaeaea' : '0')};
  min-height: 3rem;
  height: 8vh;
`;

const Button = styled(IconButton)`
  margin-left: auto;
  order: 2;
`;

export default SidepanelHeader;
